module.exports = __webpack_public_path__ + "static/media/loading.64e32a6c.svg";